import type { PermissionType, PermissionValue } from "entities/permissions";

import { SetPermissionRow } from "features/set-permission";
import { Description } from "pages/ui/page";

type Props = {
  className?: string;
  permissions: PermissionType[];
  onChange: (permission: PermissionType, newValue: PermissionValue) => void;
};

export const Permissions = (props: Props) => {
  const { className, permissions, onChange } = props;

  return (
    <section className={className}>
      <Description>Access Permissions</Description>

      <div className="grid grid-cols-1 gap-2">
        {permissions.map((permission) => {
          return (
            <SetPermissionRow
              onValueChanged={(value) => onChange(permission, value)}
              key={permission.title}
              {...permission}
            />
          );
        })}
      </div>
    </section>
  );
};
